import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Interface das Form-Komponenten implementieren muessen
 * um den Unsaved-Changes Guard zu nutzen.
 */
export interface HatUngespeicherteAenderungen {
  /** Prueft ob ungespeicherte Aenderungen existieren. */
  hatUngespeicherteAenderungen(): boolean;

  /** Zeigt den Verlassen-Dialog und gibt Observable<boolean> zurueck. */
  zeigeVerlassenDialog(): Observable<boolean>;
}

/**
 * Funktionaler CanDeactivate Guard.
 * Fragt den User ob er ungespeicherte Aenderungen verwerfen moechte.
 */
export const unsavedChangesGuard: CanDeactivateFn<HatUngespeicherteAenderungen> = (component) => {
  if (!component.hatUngespeicherteAenderungen || !component.hatUngespeicherteAenderungen()) {
    return true;
  }
  return component.zeigeVerlassenDialog();
};
